import React from 'react';
import cn from 'classnames';

import { Box, IconButton } from '@mui/material';
import { ValidationError } from 'helpers/validationRules';
import { format, getWeekForDate, isSameDay, isWithinInterval } from '../../helpers/date';
import FilterDatePicker from './FilterDatePicker';
import { styles } from './DateWeekPickerMobile.styles';

const DateWeekPickerMobile = React.memo(
  (
    props: DateWeekPickerProps & {
      isMobile?: boolean;
      screenWidth?: number;
      closeCalendarModal: () => void;
    }
  ) => {
    const { variant, error, isMobile, screenWidth, closeCalendarModal, ...rest } = props;
    const renderWrappedWeekDay = (date: Date, selectedDate: Date, dayInCurrentMonth: boolean) => {
      const dateClone = new Date(date.getTime());
      const selectedDateClone = new Date(selectedDate.getTime());
      const start = getWeekForDate(selectedDateClone).startDate;
      const end = getWeekForDate(selectedDateClone).endDate;

      const dayIsBetween = isWithinInterval(dateClone, { start, end });
      const isFirstDay = isSameDay(dateClone, start);
      const isLastDay = isSameDay(dateClone, end);

      const wrapperSx = {
        ...styles.dayWrapper,
        ...(dayIsBetween && styles.highlight),
        ...(isFirstDay && styles.firstHighlight),
        ...(isLastDay && styles.endHighlight),
      };

      const daySx = {
        ...styles.day,
        ...(!dayInCurrentMonth && styles.nonCurrentMonthDay),
        ...(dayIsBetween && !dayInCurrentMonth && styles.highlightNonCurrentMonthDay),
      };

      return (
        <Box sx={wrapperSx}>
          <IconButton sx={daySx} size="large">
            <span> {format(dateClone, 'd')} </span>
          </IconButton>
        </Box>
      );
    };

    return (
      <Box sx={styles.innerWrapper}>
        <FilterDatePicker
          {...rest}
          variant={variant}
          isMobile={true}
          closeCalendarModal={closeCalendarModal}
          parentComponent={'mobileFilterWeeks'}
        />
      </Box>
    );
  }
);

interface DateWeekPickerProps {
  error?: ValidationError | false;
  noHelper?: boolean;
  variant: 'dialog' | 'inline' | 'static';
  value?: Date | null;
  onChange?: (date: Date | null) => void;
  // Add other props as needed
}

export default DateWeekPickerMobile;
